// Metric conversion helpers. Breed data is stored in imperial (lbs, in);
// UI shows metric so the app feels native for the target audience.

export function lbsRangeToKg(range) {
  if (!range) return "";
  const parts = String(range).split("-").map((p) => parseInt(p.trim(), 10));
  const nums = parts.filter((n) => !isNaN(n));
  if (nums.length === 0) return range;
  const kg = nums.map((n) => Math.round(n * 0.4536));
  return kg.length > 1 ? `${kg[0]}-${kg[1]}` : String(kg[0]);
}

export function inRangeToCm(range) {
  if (!range) return "";
  const parts = String(range).split("-").map((p) => parseInt(p.trim(), 10));
  const nums = parts.filter((n) => !isNaN(n));
  if (nums.length === 0) return range;
  const cm = nums.map((n) => Math.round(n * 2.54));
  return cm.length > 1 ? `${cm[0]}-${cm[1]}` : String(cm[0]);
}
